// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// RxJS
import { Observable, Subject } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';
// Translate
import { TranslateService } from '@ngx-translate/core';
// Store
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
// Auth
import { AuthNoticeService, AuthService, Login } from '../../../../core/auth';
import { VacanciesService } from '../../../../core/vacancy/vacancies.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import Swal from 'sweetalert2'



@Component({
	selector: 'kt-login',
	templateUrl: './login.component.html',
	encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {
	// Public params
	loginForm: FormGroup;
	loading = false;
	isLoggedIn$: Observable<boolean>;
	errors: any = [];

	private unsubscribe: Subject<any>;

	private returnUrl: any;
	@BlockUI() blockUI: NgBlockUI;


	/**
	 * Component constructor
	 *
	 * @param router: Router
	 * @param auth: AuthService
	 * @param authNoticeService: AuthNoticeService
	 * @param translate: TranslateService
	 * @param store: Store<AppState>
	 * @param fb: FormBuilder
	 * @param cdr
	 * @param route
	 */
	constructor(
		private router: Router,
		private auth: AuthService,
		private authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private store: Store<AppState>,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute,
		private vacanCyService:  VacanciesService,
	) {
		this.unsubscribe = new Subject();
	}



	/**
	 * On init
	 */
	ngOnInit(): void {
		this.initLoginForm();
		const swalWithBootstrapButtons = Swal.mixin({
			customClass: {
			  confirmButton: 'btn btn-success',
			  cancelButton: 'btn btn-danger',
			  title:'text-danger'
			},
			buttonsStyling: false
		  })
		  
		  swalWithBootstrapButtons.fire({
			title: 'Housemanship Management System',
			html: '<p>I welcome you to the Centralized Housemanship Placement Portal of the Medical and Dental Council of Nigeria(MDCN)</p><p>Kindly note that this site is for the <span style="color:green">newly graduated</span> and <span style="color:green">inducted</span> Doctors and Dentists who are provisionally registered by the MDCN and are yet to undergo Housemanship Training</p><p></p><p style="color:green"> Signed: Dr T.A.B. Sanusi (Registrar)</p>  ',
			confirmButtonText: 'Got it',
			width: 600,
		
			showClass: {
			  popup: 'animate__animated animate__fadeInDown'
			},
			hideClass: {
			  popup: 'animate__animated animate__fadeOutUp'
			}
		  })

	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.authNoticeService.setNotice(null);
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initLoginForm() {
		

		if (!this.authNoticeService.onNoticeChanged$.getValue()) {
			const initialNotice = `Login or Register it's fast and easy
			`;
			this.authNoticeService.setNotice(initialNotice, 'success');
		}

		this.loginForm = this.fb.group({
			email: ["", Validators.compose([
				Validators.required,
				Validators.email,
				Validators.minLength(3),
				Validators.maxLength(320) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])
			],
			password: ["", Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(100)
			])
			]
		});
	}

	/**
	 * Form Submit
	 */
	submit() {
		const controls = this.loginForm.controls;
		/** check form */
		if (this.loginForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		this.loading = true;
		this.blockUI.start('Prcocessing...');
		const authData = {
			email: controls.email.value,
			password: controls.password.value
		};
		this.auth
			.login(authData.email, authData.password)
			.pipe(
				tap(user => {
				
					if (user) {
					    this.isLoggedIn$
						this.store.dispatch(new Login({authToken: user.jwt}));
						localStorage.setItem('token',user.jwt);
						this.checkposting()
						
					} else {
						
						
						this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_LOGIN'), 'danger');
					}
				},
				error=>{
					
					
					this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_LOGIN'), 'danger');
				}
				),
				
				takeUntil(this.unsubscribe),
				finalize(() => {
					this.loading = false;
					this.blockUI.stop()
					
					this.cdr.markForCheck();
				}),
				
			)
			.subscribe(user=>{
				this.loading = false;
				this.isLoggedIn$
				this.store.dispatch(new Login({authToken: user.jwt}));
				localStorage.setItem('token',user.jwt);
				
				this.checkposting()
				
			});
	}

	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.loginForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}

	checkposting(){
		this.vacanCyService.checkposting().subscribe((data)=>{
			//alert("Cheked fine")
			localStorage.setItem('PostDetails',JSON.stringify(data[0]))
			this.router.navigateByUrl('main/dashboad'); // Main page
			//this.posted = true;
		},error=>{
			console.log('checked error')
			//localStorage.removeItem('PostDetails')
			this.router.navigateByUrl('main/dashboad'); // Main page
		})
	}
}
